export default __webpack_public_path__ + "static/house_b.30675662fcfdddc3b9ba915e5a0ddf05.png";